import {useCallback} from "react";
import {ZyusetuFieldKeyFragmentFragment, ZyusetuFieldKeyType,} from "@/graphql/graphql";

import dayjs from "dayjs";

export function useGetFormattedValue() {
  
  return useCallback(
    (
      key: ZyusetuFieldKeyFragmentFragment,
      content: any,
      rawBoolean: boolean = false,
    ) => {
      if (!rawBoolean && key.keyType === ZyusetuFieldKeyType.Boolean) {
        if ([true, 1, "1", "Yes", "YES", "yes", "はい", "あり", "有り", "有"].includes(content)) {
          return "はい";
        }
        return "";
      }
      if (key.keyType === ZyusetuFieldKeyType.Date) {
        const d = dayjs(content);
        return d.isValid() ? d.format("YYYY年MM月DD日") : content;
      }
      if (key.keyType === ZyusetuFieldKeyType.PremisesLandRights) {
        return content?.map((item: any) => `${item?.index}番 (${item?.rightType})`).join(",")
      }
      if (key.keyType === ZyusetuFieldKeyType.DateMonth) {
        const d = dayjs(content);
        return d.isValid() ? d.format("YYYY年MM月") : content;
      }
      if (key.keyType === ZyusetuFieldKeyType.SelectMany) {
        return Array.isArray(content) ? content?.join(",") : content;
      }
      if (key.keyType === ZyusetuFieldKeyType.SelectManyWithCustomInput) {
        return Array.isArray(content) ? content?.join(",") : content;
      }
      if (key.keyType === ZyusetuFieldKeyType.Tenant) {
        return (content?.map((tenant: any) => `${tenant.tenant_name}(${tenant.tenant_age})`) ?? [])?.join(",");
      }
      return content;
    },
    [],
  );
}
